"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MarketplaceTooltip = _interopRequireDefault(require("../MarketplaceTooltip/MarketplaceTooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable import/no-cycle */
var MarketplaceShortcodes = function MarketplaceShortcodesFunction(_ref) {
  var identifier = _ref.identifier,
      attributes = _ref.attributes,
      tooltip = _ref.tooltip,
      styleFlag = _ref.styleFlag;

  switch (identifier) {
    case 'MarkdownTooltip':
      return /*#__PURE__*/_react["default"].createElement(_MarketplaceTooltip["default"], {
        display: true,
        hideIcon: true,
        title: attributes.title,
        message: tooltip.message,
        styleFlag: styleFlag
      });

    default:
      return null;
  }
};

MarketplaceShortcodes.propTypes = {
  identifier: _propTypes["default"].string.isRequired,
  attributes: _propTypes["default"].shape({
    title: _propTypes["default"].string,
    message: _propTypes["default"].string
  }).isRequired,
  tooltip: _propTypes["default"].shape({
    message: _propTypes["default"].string
  }),
  styleFlag: _propTypes["default"].string
};
MarketplaceShortcodes.defaultProps = {
  tooltip: undefined,
  styleFlag: 'inline'
};
var _default = MarketplaceShortcodes;
exports["default"] = _default;